import styled from 'styled-components';

export const FamiliesDropdownContainer = styled.div`
  width: 100%;
`;
